import ROUTE from '@us/app/router/appModule/names'
import routes from '@us/app/router/appModule/routes'
import hooks from '@us/app/router/appModule/hooks'

export default {
  ROUTE,
  routes,
  hooks,
}
